// extracted by mini-css-extract-plugin
module.exports = {"textLink":"styles_textLink__Q9C7q","textMyCarForum":"styles_textMyCarForum__gRPUq","containerMyCarForum":"styles_containerMyCarForum__nY3Ky"};